import {
  CDN_EXPIRATION_LOCAL_STORAGE,
  CDN_SIGNED_COOKIE,
  FB_AUTH_EXPIRATION_LOCAL_STORAGE,
  FB_ID_LOCAL_STORAGE,
  LOGIN_METHOD,
} from 'constants/api';
import { Dispatch, useCallback } from 'react';
import { deleteCookie } from 'utils/cookie';
import { SessionUser } from '../sessionProvider.types';

type TUseSessionStorage = {
  setFirebaseId: Dispatch<React.SetStateAction<string | null>>;
  setUser: Dispatch<React.SetStateAction<SessionUser | undefined>>;
};

export const useSessionStorage = ({
  setFirebaseId,
  setUser,
}: TUseSessionStorage) => {
  const getExpiresIn = useCallback(
    () => Number(sessionStorage.getItem(FB_AUTH_EXPIRATION_LOCAL_STORAGE)),
    [],
  );

  const updateExpiresIn = useCallback((updatedExpiresIn: string) => {
    sessionStorage.setItem(FB_AUTH_EXPIRATION_LOCAL_STORAGE, updatedExpiresIn);
  }, []);

  const updateFirebaseId = useCallback(
    (updatedFirebaseId: string) => {
      sessionStorage.setItem(FB_ID_LOCAL_STORAGE, updatedFirebaseId);
      setFirebaseId(updatedFirebaseId);
    },
    [setFirebaseId],
  );

  const clearSessionStorage = async () => {
    sessionStorage.removeItem(FB_AUTH_EXPIRATION_LOCAL_STORAGE);
    sessionStorage.removeItem(FB_ID_LOCAL_STORAGE);
    sessionStorage.removeItem(LOGIN_METHOD);
    // delete apollo cache
    localStorage.removeItem('apollo-cache-persist');
    // delete CDN expiration date
    localStorage.removeItem(CDN_EXPIRATION_LOCAL_STORAGE);
    // deleteCookie(FB_AUTH_COOKIE);
    deleteCookie(CDN_SIGNED_COOKIE);
    // Ensure all cleanups are processed
    await new Promise((resolve) => setTimeout(resolve, 0));
  };

  const clearSessionFirebase = useCallback(async () => {
    setFirebaseId(null);
    await clearSessionStorage();
  }, [setFirebaseId]);

  const clearSessionUser = useCallback(async () => {
    setUser(undefined);
    setFirebaseId(null);
    await clearSessionStorage();
  }, [setFirebaseId, setUser]);

  return {
    getExpiresIn,
    updateExpiresIn,
    updateFirebaseId,
    clearSessionFirebase,
    clearSessionUser,
    clearSessionStorage,
  };
};
